import React from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {TextG14} from '../typography';

interface ToggleChipProps {
  label: string;
  emoji?: string;
  isSelected: boolean;
  onToggle: () => void;
}

const ToggleChip = ({label, emoji, isSelected, onToggle}: ToggleChipProps) => {
  return (
    <Box
      as="button"
      type="button"
      onClick={onToggle}
      px={4}
      py={2}
      borderRadius="24px"
      border="1px solid"
      borderColor={isSelected ? '#1A1A1A' : '#E5E5E5'}
      bg={isSelected ? '#1A1A1A' : 'white'}
      color={isSelected ? 'white' : '#1A1A1A'}
      transition="all 0.15s ease"
      _active={{transform: 'scale(0.96)'}}
      whiteSpace="nowrap">
      <Flex align="center" gap={1.5}>
        {emoji && <span>{emoji}</span>}
        <TextG14 mt="0" color="inherit">
          {label}
        </TextG14>
      </Flex>
    </Box>
  );
};

export default ToggleChip;
